/**
 * Die Adressen der öffentlichen Ranglisten — EINE Stelle für den Browser
 * (`publicLeaderboardAPI` in `services/api.ts`) und die Server-Seiten
 * (Next.js-Phase 2, `app/_seo/lokal.ts`). Die Server-Seite muss genau die
 * Antwort holen, die der Browser auf derselben Adresse bekäme; zwei Fassungen
 * der Query wären zwei Antworten.
 */

/** So viele Einträge holt die Community-Seite (die Liste filtert danach im Browser). */
export const RANGLISTE_LIMIT = 1000;

export const RANGLISTE_STATISTIK_PFAD = '/api/public/leaderboard/stats';

export const RANKING_LAENDER_PFAD = '/api/i18n/countries/with-ranking';

export function ranglistenPfad(
  metric: string,
  limit: number = RANGLISTE_LIMIT,
  country: string | null = null,
  lang: string | null = null,
  username: string | null = null,
): string {
  let url = `/api/public/leaderboard/${metric}?limit=${limit}`;
  if (country) url += `&country=${country}`;
  if (lang) url += `&lang=${lang}`;
  if (username) url += `&username=${encodeURIComponent(username)}`;
  return url;
}

export function architektenPfad(country: string | null = null, lang: string | null = null): string {
  const params: string[] = [];
  if (country) params.push(`country=${country}`);
  if (lang) params.push(`lang=${lang}`);
  return '/api/public/leaderboard/architects' + (params.length ? `?${params.join('&')}` : '');
}

/**
 * Wovon der erste Stand der Community-Seite abhängt — der Schlüssel, unter dem
 * eine Server-Seite ihn vorlegt (`legeRanglisteVor`) und unter dem die Seite
 * ihn sucht. Passt er nicht, lädt die Seite selbst.
 */
export function ranglistenSchluessel({
  view,
  metric,
  country,
  user,
  language,
}: {
  view: string;
  metric: string;
  country: string | null;
  user: string | null;
  language: string;
}): string {
  return [view, metric, country || '', user || '', language].join('|');
}
